import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  Tabs,
  Tab,
  Paper,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  TextField,
  IconButton,
  Alert,
  Tooltip,
  Divider,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import DeleteIcon from "@mui/icons-material/Delete";
import SearchIcon from "@mui/icons-material/Search";
import FolderIcon from "@mui/icons-material/Folder";
import { useLocation, useNavigate } from "react-router-dom";
import { API_BASE_PATH, API_BASE_RELATIVE_PATH } from "../../Config/Config";
import { CommonMethods } from "../../components/common/CommonMethods";
import {
  fetchProducts,
  fetchModules,
  fetchEnvironments,
  fetchTestCasesfromModule,
} from "../../API/CreateCollectionAPI";
import { fetchAllApiDetails, fetchAllAutoApiDetails, deleteApi } from "../../API/Api";
import ApiCall from "../../components/ApiCall/ApiCall.component";
import { HelpIconButton } from "../../components-new/help/help-modal";
import apiFetch from "../../utils/apiFetch";

const StyledPaper = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(3),
  marginBottom: theme.spacing(3),
  backgroundColor: theme.palette.background.paper,
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: theme.shape.borderRadius,
  boxShadow: "0 2px 4px rgba(0,0,0,0.05)",
}));

const StyledButton = styled(Button)(({ theme }) => ({
  backgroundColor: "#FF6B00",
  color: "#FFFFFF",
  "&:hover": {
    backgroundColor: "#FF8533",
  },
  "&.Mui-disabled": {
    backgroundColor: "#FFB74D",
    color: "#FFFFFF",
  },
}));

const ActionButton = styled(Button)(({ theme }) => ({
  backgroundColor: "#2550D1",
  color: "#FFFFFF",
  "&:hover": {
    backgroundColor: "#1B3AA3",
  },
  "&.Mui-disabled": {
    backgroundColor: "#A5B4E5",
    color: "#FFFFFF",
  },
}));

const StyledTabs = styled(Tabs)(({ theme }) => ({
  borderBottom: "1px solid #e8e8e8",
  "& .MuiTabs-indicator": {
    backgroundColor: "#FF6B00",
    height: 3,
  },
  "& .MuiTab-root": {
    textTransform: "none",
    minWidth: 72,
    fontWeight: theme.typography.fontWeightRegular,
    marginRight: theme.spacing(4),
    color: "#666666",
    "&:hover": {
      color: "#FF6B00",
      opacity: 1,
    },
    "&.Mui-selected": {
      color: "#FF6B00",
      fontWeight: theme.typography.fontWeightMedium,
    },
  },
}));

const StyledTab = styled(Tab)(({ theme }) => ({
  textTransform: "none",
  fontWeight: theme.typography.fontWeightRegular,
  fontSize: theme.typography.pxToRem(15),
  marginRight: theme.spacing(1),
  color: "#666666",
  "&.Mui-selected": {
    color: "#FF6B00",
    fontWeight: theme.typography.fontWeightMedium,
  },
}));

const ControlsContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  gap: theme.spacing(2),
  flexWrap: "wrap",
  marginBottom: theme.spacing(3),
  backgroundColor: "#FFFFFF",
  borderRadius: theme.shape.borderRadius,
  padding: theme.spacing(2),
  border: "1px solid #FFE0B2",
  boxShadow: "0 2px 4px rgba(0,0,0,0.05)",
}));

const FormControlWrapper = styled(FormControl)(({ theme }) => ({
  flex: 1,
  minWidth: "300px",
  maxWidth: "300px",
  width: "300px",
}));

const SplitView = styled(Box)(({ theme }) => ({
  display: "flex",
  gap: theme.spacing(2),
  width: "100%",
  backgroundColor: "#FFFFFF",
  borderRadius: theme.shape.borderRadius,
  padding: theme.spacing(2),
  minHeight: "calc(100vh - 200px)",
}));

const LeftPanel = styled(Box)(({ theme }) => ({
  flex: 1,
  display: "flex",
  flexDirection: "column",
  border: `1px solid #E0E0E0`,
  borderRadius: theme.shape.borderRadius,
  overflow: "hidden",
  minWidth: "300px",
  maxWidth: "400px",
  backgroundColor: "#FFFFFF",
  boxShadow: "0 2px 4px rgba(0,0,0,0.05)",
  height: "100%",
  "& > *:first-of-type": {
    flex: "0 0 auto",
    backgroundColor: "#FFFFFF",
  },
  "& > *:last-of-type": {
    flex: 1,
    overflow: "auto",
    minHeight: 0,
    "&::-webkit-scrollbar": {
      width: "8px",
    },
    "&::-webkit-scrollbar-track": {
      background: "#F5F5F5",
    },
    "&::-webkit-scrollbar-thumb": {
      background: "#2550D1",
      borderRadius: "4px",
    },
  },
}));

const RightPanel = styled(Box)(({ theme }) => ({
  flex: 2,
  border: `1px solid #E0E0E0`,
  borderRadius: theme.shape.borderRadius,
  overflow: "hidden",
  width: "800px",
  display: "flex",
  flexDirection: "column",
  backgroundColor: "#FFFFFF",
  boxShadow: "0 2px 4px rgba(0,0,0,0.05)",
  minHeight: "calc(100vh - 200px)",
  "& > *": {
    width: "100%",
  },
}));

const APIPage = () => {
  const navigate = useNavigate();
  const userDetails = localStorage.getItem("userDetail");
  const temp = JSON.parse(userDetails);
  const path = useLocation().pathname;

  const [activeTab, setActiveTab] = useState(0);
  const [state, setState] = useState({
    ResolutionList: [],
    URLList: [],
    idproducts: "",
    idproductsApi: "",
    idmodules: "",
    idmodulesApi: "",
    idtest_case: "",
    SelectEnvironmentName: "",
    SelectEnvironmentUrl: "",
    email: "",
    password: "",
    company: "",
  });

  const [apiData, setApiData] = useState({});
  const [LoadApiSide, setLoadApiSide] = useState(false);
  const [loadAutoApiSide, setLoadAutoApiSide] = useState(false);
  const [productList, setProductList] = useState([]);
  const [prevApiList, setPrevApiList] = useState([]);
  const [prevAutoApiList, setPrevAutoApiList] = useState([]);
  const [moduleList, setModuleList] = useState([]);
  const [testCaseList, setTestCaseList] = useState([]);
  const [product, setProduct] = useState("");
  const [uploadFile, setUploadFile] = useState(null);
  const [searchString, setSearchString] = useState("");
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);
  const [openDeleteAlert, setOpenDeleteAlert] = useState(false);
  const [deleteIconValue, setDeleteIconValue] = useState(null);

  const [customApiState, setCustomApiState] = useState({
    idproducts: "",
    idproductsApi: "",
    idmodules: "",
    idmodulesApi: "",
    idtest_case: "",
    SelectEnvironmentName: "",
    SelectEnvironmentUrl: "",
  });

  const [autoApiState, setAutoApiState] = useState({
    idproducts: "",
    idproductsApi: "",
    idmodules: "",
    idmodulesApi: "",
    idtest_case: "",
    SelectEnvironmentName: "",
    SelectEnvironmentUrl: "",
  });

  useEffect(() => {
    getProducts();
  }, []);

  const getProducts = async () => {
    try {
      const response = await fetchProducts({
        companyid: temp.companyid,
        token: temp.token,
      });
      if (response.status === 200) {
        if (response.data.message === "fail") {
          CommonMethods(navigate);
        } else {
          setProductList(response.data);
        }
      }
    } catch (error) {
      console.error("Error fetching products:", error);
      setError("Failed to fetch products");
    }
  };

  const getModules = async (productId) => {
    try {
      const response = await fetchModules(productId);
      if (response.status === 200) {
        setModuleList(response.data);
      }
    } catch (error) {
      console.error("Error fetching modules:", error);
      setError("Failed to fetch modules");
    }
  };

  const handleTabChange = (event, newValue) => {
    // Save current state before switching
    if (activeTab === 0) {
      setCustomApiState(state);
    } else {
      setAutoApiState(state);
    }

    // Restore state for the tab being switched to
    if (newValue === 0) {
      setState(customApiState);
      if (customApiState.idmodules) {
        getAllApiDetails(customApiState.idmodules);
      }
    } else {
      setState(autoApiState);
      if (autoApiState.idproducts) {
        getAllAutoApiDetails(autoApiState.idproducts);
      }
    }

    setActiveTab(newValue);
  };

  const handleFileUpload = (event) => {
    const file = event.target.files[0];
    if (file) {
      const extension = file.name.split(".").pop().toLowerCase();
      if (extension === "json") {
        setUploadFile(file);
        setError(null);
      } else {
        setError("Please upload a JSON file");
        event.target.value = null;
      }
    }
  };

  const handleUpload = async () => {
    if (!uploadFile || !state.idproducts || !state.idmodules) {
      setError("Please select a file, product, and module");
      return;
    }

    try {
      const response = await apiFetch(
        `${API_BASE_PATH}${API_BASE_RELATIVE_PATH}?action=ingestSwagger&companyid=${temp.companyid}&product=${state.idproducts}&module=${state.idmodules}&fileName=${uploadFile.name}`,
        {
          method: "POST",
          body: uploadFile,
          headers: {
            "content-type": uploadFile.type,
            "content-length": `${uploadFile.size}`,
          },
        },
      );

      if (response.ok) {
        setSuccess("File uploaded successfully");
        setUploadFile(null);
        getAllApiDetails(state.idmodules);
      } else {
        setError("Failed to upload file");
      }
    } catch (error) {
      console.error("Error uploading file:", error);
      setError("Failed to upload file");
    }
  };

  const handleDelete = async (apiId, modid) => {
    try {
      console.log("Deleting API with:", {
        companyid: temp.companyid,
        token: temp.token,
        apiid: apiId,
        moduleid: modid,
      });
      const response = await deleteApi({
        companyid: temp.companyid,
        token: temp.token,
        apiid: apiId,
        moduleid: modid,
      });

      if (response.status === 200) {
        setSuccess("API deleted successfully");
        getAllApiDetails(state.idmodules);
      } else {
        setError("Failed to delete API");
      }
    } catch (error) {
      console.error("Error deleting API:", error);
      setError("Failed to delete API");
    }
  };

  const getAllApiDetails = async (moduleId) => {
    try {
      console.log("Fetching API details with:", {
        companyid: temp.companyid,
        token: temp.token,
        product: state.idproducts,
        moduleid: moduleId,
      });
      const response = await fetchAllApiDetails({
        companyid: temp.companyid,
        token: temp.token,
        product: state.idproducts,
        moduleid: moduleId,
      });
      if (response.status === 200) {
        console.log("API Details:", response.data);
        setPrevApiList(response.data);
      }
    } catch (error) {
      console.error("Error fetching API details:", error);
      setError("Failed to fetch API details");
    }
  };

  const getAllAutoApiDetails = async (productId) => {
    try {
      const response = await fetchAllAutoApiDetails({
        companyid: temp.companyid,
        token: temp.token,
        product: productId,
      });
      if (response.status === 200) {
        setPrevAutoApiList(response.data);
      }
    } catch (error) {
      console.error("Error fetching Auto API details:", error);
      setError("Failed to fetch Auto API details");
    }
  };

  const handleClickOpenDeleteAlert = () => {
    setOpenDeleteAlert(true);
  };

  const handleCloseDeleteAlert = () => {
    setOpenDeleteAlert(false);
  };

  return (
    <Box sx={{ width: "100%", p: 3, backgroundColor: "#FFFFFF" }}>
      {/* <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 3 }}>
        <HelpIconButton path={path} />
      </Box> */}

      {error && (
        <Alert severity="error" sx={{ mb: 2 }}>
          {error}
        </Alert>
      )}

      {success && (
        <Alert severity="success" sx={{ mb: 2 }}>
          {success}
        </Alert>
      )}

      <StyledTabs value={activeTab} onChange={handleTabChange}>
        <StyledTab label="Custom API" />
        <StyledTab label="Auto API" />
      </StyledTabs>

      <StyledPaper>
        <ControlsContainer>
          <FormControlWrapper>
            <InputLabel>Select Product</InputLabel>
            <Select
              value={state.idproducts}
              onChange={(e) => {
                const selectedProductId = e.target.value;
                setState({ ...state, idproducts: selectedProductId, idmodules: "" });
                getModules(selectedProductId);
              }}
            >
              {productList.map((product) => (
                <MenuItem key={product.idproducts} value={product.idproducts}>
                  {product.productname}
                </MenuItem>
              ))}
            </Select>
          </FormControlWrapper>

          <FormControlWrapper>
            <InputLabel>Select Module</InputLabel>
            <Select
              value={state.idmodules}
              onChange={(e) => {
                const selectedModuleId = e.target.value;
                setState({ ...state, idmodules: selectedModuleId });
                if (state.idproducts && selectedModuleId) {
                  getAllApiDetails(selectedModuleId);
                }
              }}
              disabled={!state.idproducts}
            >
              {moduleList.map((module) => (
                <MenuItem key={module.idmodules} value={module.idmodules}>
                  {module.modulename}
                </MenuItem>
              ))}
            </Select>
          </FormControlWrapper>

          <Box sx={{ display: "flex", gap: 2, alignItems: "center" }}>
            <ActionButton variant="contained" component="label" startIcon={<CloudUploadIcon />}>
              Upload JSON
              <input type="file" hidden accept=".json" onChange={handleFileUpload} />
            </ActionButton>
            {uploadFile && (
              <Typography variant="body2" color="text.secondary">
                {uploadFile.name}
              </Typography>
            )}
            <ActionButton
              variant="contained"
              onClick={handleUpload}
              disabled={!uploadFile || !state.idproducts || !state.idmodules}
            >
              Upload
            </ActionButton>
          </Box>
        </ControlsContainer>
      </StyledPaper>

      <SplitView>
        <LeftPanel>
          <Box sx={{ p: 2, borderBottom: 1, borderColor: "#E0E0E0", backgroundColor: "#FFFFFF" }}>
            <TextField
              fullWidth
              placeholder="Search APIs..."
              value={searchString}
              onChange={(e) => setSearchString(e.target.value)}
              InputProps={{
                startAdornment: <SearchIcon sx={{ mr: 1, color: "#2550D1" }} />,
              }}
              sx={{
                mb: 2,
                "& .MuiOutlinedInput-root": {
                  "& fieldset": { borderColor: "#E0E0E0" },
                  "&:hover fieldset": { borderColor: "#2550D1" },
                  "&.Mui-focused fieldset": { borderColor: "#2550D1" },
                },
              }}
            />
            <ActionButton
              fullWidth
              onClick={() => {
                setApiData({ newApi: true });
                setLoadApiSide(true);
              }}
            >
              New API
            </ActionButton>
          </Box>
          <Box sx={{ p: 2, flex: 1, overflow: "auto" }}>
            {(activeTab === 0 ? prevApiList : prevAutoApiList)
              .filter((api) => api.name.toLowerCase().includes(searchString.toLowerCase()))
              .map((api) => (
                <Box
                  key={api.idapi}
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    p: 1,
                    mb: 1,
                    borderRadius: 1,
                    border: "1px solid #FFE0B2",
                    "&:hover": {
                      backgroundColor: "#FFF5EB",
                      cursor: "pointer",
                    },
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      cursor: "pointer",
                      flex: 1,
                    }}
                    onClick={() => {
                      setApiData(api);
                      if (activeTab === 0) {
                        setLoadApiSide(true);
                        setLoadAutoApiSide(false);
                      } else {
                        setLoadAutoApiSide(true);
                        setLoadApiSide(false);
                      }
                    }}
                  >
                    <FolderIcon sx={{ mr: 1, color: "#FF6B00" }} />
                    <Typography sx={{ color: "#333333" }}>{api.name}</Typography>
                  </Box>
                  <IconButton
                    color="error"
                    onClick={() => {
                      setDeleteIconValue(api.idapi);
                      handleClickOpenDeleteAlert();
                    }}
                    sx={{
                      color: "#FF6B00",
                      "&:hover": { backgroundColor: "#FFF5EB" },
                    }}
                  >
                    <DeleteIcon />
                  </IconButton>
                </Box>
              ))}
          </Box>
        </LeftPanel>
        <RightPanel>
          {LoadApiSide && activeTab === 0 && (
            <Box sx={{ p: 2 }}>
              {state.idproducts && state.idmodules && (
                <ApiCall
                  idproducts={state.idproducts}
                  idmodules={state.idmodules}
                  SelectEnvironmentName={state.SelectEnvironmentName}
                  SelectEnvironmentUrl={state.SelectEnvironmentUrl}
                  apiData={apiData}
                  value="custom"
                />
              )}
            </Box>
          )}
          {loadAutoApiSide && activeTab === 1 && (
            <Box sx={{ p: 2 }}>
              {state.idproducts && state.idmodules && (
                <ApiCall
                  idproducts={state.idproducts}
                  idmodules={state.idmodules}
                  SelectEnvironmentName={state.SelectEnvironmentName}
                  SelectEnvironmentUrl={state.SelectEnvironmentUrl}
                  apiData={apiData}
                  value="custom"
                />
              )}
            </Box>
          )}
          {!LoadApiSide && !loadAutoApiSide && (
            <Box
              sx={{
                p: 2,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                height: "100%",
                color: "#666666",
              }}
            >
              <Typography variant="h6">Select an API from the list to view details</Typography>
            </Box>
          )}
        </RightPanel>
      </SplitView>

      <Dialog
        open={openDeleteAlert}
        onClose={handleCloseDeleteAlert}
        PaperProps={{
          sx: {
            borderRadius: 2,
            minWidth: "400px",
            backgroundColor: "#FFFFFF",
            "& .MuiDialogTitle-root": {
              color: "#2550D1",
              fontWeight: 600,
            },
          },
        }}
      >
        <DialogTitle>Delete API</DialogTitle>
        <DialogContent>
          <Typography sx={{ mt: 1, color: "#333333" }}>
            Are you sure you want to delete this API? This action cannot be undone.
          </Typography>
        </DialogContent>
        <DialogActions sx={{ p: 2, pt: 0 }}>
          <Button
            onClick={handleCloseDeleteAlert}
            sx={{
              color: "#666666",
              "&:hover": {
                backgroundColor: "#F5F5F5",
                color: "#2550D1",
              },
            }}
          >
            Cancel
          </Button>
          <ActionButton
            onClick={() => {
              handleCloseDeleteAlert();
              handleDelete(deleteIconValue, state.idmodules);
            }}
          >
            Delete
          </ActionButton>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default APIPage;
